//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Shishi from "../components/shishi";
import pieChart from "../components/pieChart";
import Rose from "../components/rose";
import zhuxing from "../components/duidie_zhuxing";
import Dzhuxing from "../components/d_zhuxingTwo";
// import Dzhuxing from "../components/d_zhuxing";
import Scroll from "../components/Scroll";
import Zonglan from "../components/zonglan";
import Fuwu from "../components/fuwu";
import Zhemian from "../components/zhexian_mianji";
import Zhemian1 from "../components/zhexian_mianji1";
import Dangqian from "../components/dangqian";
import pie from "../components/pieChart.vue";
export default {
  components: {
    pieChart,
    pie,
    Scroll,
    zhuxing,
    Dzhuxing,
    Rose,
    Shishi,
    Zonglan,
    Fuwu,
    Zhemian,
    Zhemian1,
    Dangqian,
  },
  data() {
    return {
      // https://byapi.shyunhua.com
      url:'https://byapi.shyunhua.com',
      // url:'http://118.196.38.138:18092',
      listPrevData: [],
      listNextData: [],
      xData: [],//窗口
      yData:[],// 办件数量
      manyiduList: [
                {name: "非常满意",per:'100%',value: 12},
                {name: "满意",per:'0%', value: 0},
                {name: "基本满意",per:'0%', value: 0},
                {name: "不满意",per:'0%', value: 0},
                {name: "非常不满意",per:'0%', value: 0},
              ],
      chuangkou: ['01','02','03','04','05','06','07','08','09','10','11','12','13'],//窗口
      manyi: [0, 0, 0, 0,0, 0, 0,0, 0, 0, 0,0, 0],//基本满意
      hmanyi: [0, 0, 0, 0,0, 0, 0,0, 0, 0, 0,0, 0],//满意
      yiban: [0, 0, 0, 0,0, 0, 0,0, 0, 0, 0,0, 0],//不满意
      fmanyi: [12, 20, 1,23,12, 22, 10,22, 14, 24, 23,18, 11],//非常满意
      bu: [0, 0, 0, 0,0, 0, 0,0, 0, 0, 0,0, 0],//不满意数量
      verySatisfiedNum:0,
      basicallySatisfiedNum:0,
      generallySatisfiedNum:0,
      qhslnum:0,
      dissatisfiedNum:0,
      businessList: [],
      ssyyList: {
        today: "",
        history: "",
        list: [],
      },
      ck_manyiduList: [],
      serverList: [
        // {
        //   picture: require("../assets/image01.jpg"),
        //   name: "樊舒雅",
        //   window: "企业设立",
        // },
        // {
        //   picture: require("../assets/image02.jpg"),
        //   name: " 苑婷",
        //   window: "企业设立",
        // },
        // {
        //   picture: require("../assets/image03.jpg"),
        //   name: "梁越",
        //   window: "企业设立",
        // }
      ],
      Data_time: [9, 10, 11, 12, 13, 14, 15, 16, 17],
      Data1: [],
      Data1_time: [],
      Data1_num: [],
      shijian: {
        year: "",
        month: "",
        day: "",
        hour: "",
        fen: "",
        miao: "",
        // nongli:'农历冬月初十'
        nongli: "",
      },
      urlTime: {
        year: "",
        month: "",
        day: "",
        hour: "",
      },
      CalendarData: [],
      weekString: "日一二三四五六",
      sx: "鼠牛虎兔龙蛇马羊猴鸡狗猪",
      cYear: "",
      cMonth: "",
      cDay: "",
      TheDate: "",
      timer1: "",
      timer2: "",
      shangbao: 0,
      banjie: 0,
      zong:0,
      averageTime: 0,
      //计算从2021年8月11日起计算到现在的时间差天数
      allDay:Math.floor((new Date().getTime() - new Date('2021-8-11').getTime()) / (1000 * 60 * 60 * 24)),
      average: 0,
      qufen: 1002,
      muted:true,
      swiperOptions: {
        autoplay: {
        	delay:1000*60*60*24,
        	// stopOnLastSlide: false,
        	disableOnInteraction: true
        },
        // autoplay: false,
        speed: 1000,
        loop: true,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // pagination: {
        // 	el: '.swiper-pagination',
        // 	clickable: true
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: ()=> {
            if(this.$refs.mySwiper.swiper === null)return
            if (this.$refs.videoPlayer[0]) {
              this.$refs.mySwiper.swiper && this.$refs.mySwiper.swiper.autoplay && this.$refs.mySwiper.swiper.autoplay.stop();
              this.$refs.videoPlayer[0].play();
              setTimeout(() => {
                this.$refs.videoPlayer[0].pause();
                this.$refs.mySwiper.swiper && this.$refs.mySwiper.swiper.autoplay && this.$refs.mySwiper.swiper.autoplay.start();
              }, this.$refs.videoPlayer[0].duration && this.$refs.videoPlayer[0].duration.toFixed(2) * 1000);
            }
            if (this.$refs.videoPlayer[1]) {
              this.$refs.videoPlayer[1].play();
              this.$refs.mySwiper.swiper.autoplay && this.$refs.mySwiper.swiper.autoplay.stop();
              setTimeout(() => {
                this.$refs.videoPlayer[1].pause();
                this.$refs.mySwiper.swiper.autoplay && this.$refs.mySwiper.swiper.autoplay.start();
              }, this.$refs.videoPlayer[1].duration && this.$refs.videoPlayer[1].duration.toFixed(2) * 1000);
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    // if(this.$route.query.id==1){
    // 	this.qufen=1002
    // }else{
    // 	this.qufen=1001
    // }
    // this.qufen=this.$route.query.id
    var that = this;
    that.CalendarData = new Array( 0xa4b, 0x5164b,
      0x6a5, 0x6d4, 0x415b5, 0x2b6, 0x957,0x2092f,
      0x497, 0x60c96, 0xd4a,  0xea5, 0x50da9,
      0x5ad, 0x2b6, 0x3126e, 0x92e, 0x7192d,
      0xc95, 0xd4a, 0x61b4a, 0xb55, 0x56a, 0x4155b,
      0x25d, 0x92d, 0x2192b, 0xa95, 0x71695,
      0x6ca, 0xb55, 0x50ab5, 0x4da, 0xa5b, 0x30a57,
      0x52b, 0x8152a, 0xe95, 0x6aa, 0x615aa,
      0xab5, 0x4b6, 0x414ae, 0xa57, 0x526, 0x31d26,
      0xd95, 0x70b55,
      0x56a, 0x96d, 0x5095d, 0x4ad, 0xa4d, 0x41a4d,
      0xd25, 0x81aa5,
      0xb54, 0xb6a, 0x612da,
      0x95b, 0x49b, 0x41497,
      0xa4b, 0xa164b, 0x6a5, 0x6d4, 0x615b4, 0xab6, 0x957,
      0x5092f, 0x497, 0x64b, 0x30d4a, 0xea5, 0x80d65, 0x5ac,
      0xab6, 0x5126d, 0x92e, 0xc96, 0x41a95, 0xd4a, 0xda5,
      0x20b55, 0x56a, 0x7155b, 0x25d, 0x92d, 0x5192b, 0xa95,
      0xb4a, 0x416aa, 0xad5, 0x90ab5, 0x4ba, 0xa5b, 0x60a57,
      0x52b, 0xa93, 0x40e95
    );
    that.init();
    that.shixiang();
    that.fuwu();
    this.processing();
      this.window();
    setTimeout(() => {
      that.all();
    }, 2000);
    this.getData()
  },
  mounted() {
    this.timer1 = setInterval(() => {
      this.init();
    }, 1000);
    this.timer2 = setInterval(() => {
      this.shixiang();
      this.chuangkou_manyidu();
      // this.businessFun()
      // this.getManyiList();
      this.ssyy();
      this.window();
    }, 60 * 1000);
    this.chuangkou_manyidu();
    // this.getManyiList();
  },
  activated() {},
  destroyed() {
    clearInterval(this.timer1);
    clearInterval(this.timer2);
  },
  methods: {
    getData() {
      this.pbcFun.axios.http(this.url+"/api/hexipoyu-file-manage/getHeXiPoYuServiceLobbyManage").then((response) => {
        const arr = response.reverse()
        if (arr.length) {
          const next = arr.splice(arr.findIndex(item => item.id === 1)).filter(item => item.id !== 1)
          const prev = arr
          this.listPrevData = prev
          this.listNextData = next
          console.log(this.listPrevData,this.listNextData,9999)
        }
      })
    },
    init() {
      var sWeek = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      var D = new Date();
      var yy = D.getFullYear();
      var mm = D.getMonth() + 1;
      var dd = D.getDate();
      var ww = D.getDay();

      this.urlTime.year = yy;
      if (mm > 9) {
        this.urlTime.month = mm;
      } else {
        this.urlTime.month = "0" + mm;
      }
      if (dd > 9) {
        this.urlTime.day = dd;
      } else {
        this.urlTime.day = "0" + dd;
      }
      this.urlTime.hour = D.getHours();

      var ss = parseInt(D.getTime() / 1000);
      var dNow = new Date();
      var sValue =
        this.getFullYear(dNow) +
        "年" +
        (dNow.getMonth() + 1) +
        "月" +
        dNow.getDate() +
        "日" +
        " " +
        sWeek[dNow.getDay()] +
        " ";
      this.shijian.nongli = "农历" + this.GetLunarDay(yy, mm, dd);
      this.shijian.year = yy; //获取当前年份
      this.shijian.month = mm; //获取当前月份
      this.shijian.day = dd; //获取当前日
      this.shijian.xingqi = sWeek[dNow.getDay()]; //获取当前星期几
      this.shijian.hour =
        D.getHours() >= 10 ? D.getHours() : "0" + D.getHours(); //获取小时
      this.shijian.fen =
        D.getMinutes() >= 10 ? D.getMinutes() : "0" + D.getMinutes(); //获取分钟
      this.shijian.miao =
        D.getSeconds() >= 10 ? D.getSeconds() : "0" + D.getSeconds();
    },
    getFullYear(d) {
      // 修正firefox下year错误
      var yr = d.getYear();
      if (yr < 1000) yr += 1900;
      return yr;
    },
    GetLunarDay(solarYear, solarMonth, solarDay) {
      if (solarYear < 1921 || solarYear > 2090) {
        return "";
      } else {
        solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
        this.e2c(solarYear, solarMonth, solarDay);
        return this.GetcDateString();
      }
    },
    GetcDateString() {
      var tgString = "甲乙丙丁戊己庚辛壬癸";
      var dzString = "子丑寅卯辰巳午未申酉戌亥";
      var monString = "正二三四五六七八九十冬腊";
      var numString = "一二三四五六七八九十";

      var tmp = "";
      // 什么年份
      // 					tmp += tgString.charAt((this.cYear - 4) % 10);
      // 					tmp += dzString.charAt((this.cYear - 4) % 12);
      // 					tmp += "年 ";
      if (this.cMonth < 1) {
        tmp += "(闰)";
        tmp += monString.charAt(-this.cMonth - 1);
      } else {
        tmp += monString.charAt(this.cMonth - 1);
      }
      tmp += "月";
      tmp +=
        this.cDay < 11
          ? "初"
          : this.cDay < 20
          ? "十"
          : this.cDay < 30
          ? "廿"
          : "三十";
      if (this.cDay % 10 != 0 || this.cDay == 10) {
        tmp += numString.charAt((this.cDay - 1) % 10);
      }
      return tmp;
    },
    e2c() {
      this.TheDate =
        arguments.length != 3
          ? new Date()
          : new Date(arguments[0], arguments[1], arguments[2]);

      var total, m, n, k;
      var isEnd = false;
      var tmp = this.TheDate.getFullYear();
      var madd = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      total =
        (tmp - 1921) * 365 +
        Math.floor((tmp - 1921) / 4) +
        madd[this.TheDate.getMonth()] +
        this.TheDate.getDate() -
        38;

      if (this.TheDate.getYear() % 4 == 0 && this.TheDate.getMonth() > 1) {
        total++;
      }
      for (m = 0; ; m++) {
        k = this.CalendarData[m] < 0xfff ? 11 : 12;
        for (n = k; n >= 0; n--) {
          if (total <= 29 + this.GetBit(this.CalendarData[m], n)) {
            isEnd = true;
            break;
          }
          total = total - 29 - this.GetBit(this.CalendarData[m], n);
        }
        if (isEnd) break;
      }
      this.cYear = 1921 + m;
      this.cMonth = k - n + 1;

      this.cDay = total;
      if (k == 12) {
        if (this.cMonth == Math.floor(this.CalendarData[m] / 0x10000) + 1) {
          this.cMonth = 1 - this.cMonth;
        }
        if (this.cMonth > Math.floor(this.CalendarData[m] / 0x10000) + 1) {
          this.cMonth--;
        }
      }
    },
    GetBit(m, n) {
      return (m >> n) & 1;
    },
    all() {
      var that = this;
      // that.chuangkou_manyidu();
      that.ssyy();
      // that.manyidu();
      // that.businessFun()
    },
    ssyy() {
      this.pbcFun.axios.http("https://hxapi.shyunhua.com/Appointment/screen").then((response) => {
        if (response.code == 0) {
          this.ssyyList = {
            today: "",
            history: "",
            list: [],
          };
          var array = ["未取号", "已取号", "已取消", "可补号", "已过号未取"];
          for (var i = 0; i < response.data.info.length; i++) {
            response.data.info[i].status =
              array[Number(response.data.info[i].status) - 1];
          }
          this.ssyyList.today = response.data.today;
          this.ssyyList.history = response.data.total;
          this.banjie = response.data.today4boyu;
          for (var i = 0; i < response.data.info.length; i++) {
            if (response.data.info[i].name) {
              this.ssyyList.list.push(response.data.info[i]);
            }
          }
        }
      });
    },
    chuangkou_manyidu() {
      this.manyiduList= [
                {name: "非常满意",per:'100%',value: 0},
                {name: "满意",per:'0%', value: 0},
                {name: "基本满意",per:'0%', value: 0},
                {name: "不满意",per:'0%', value: 0},
                {name: "非常不满意",per:'0%', value: 0},
              ]
      this.chuangkou = []
      this.manyi = []//基本满意
      this.hmanyi = []//满意
      this.yiban = []//不满意
      this.fmanyi = []//非常满意
      this.bu = []//不满意数量
      this.pbcFun.axios
        .http(
          "https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=WindowCount&StartDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            this.urlTime.day +
            "&EndDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day
        )
        .then((response) => {
          this.manyiduList = [
                {name: "非常满意",per:'100%',value: response.data.reduce((acc, cur) => acc + cur.Num, 0)},
                {name: "满意",per:'0%', value: 0},
                {name: "基本满意",per:'0%', value: 0},
                {name: "不满意",per:'0%', value: 0},
                {name: "非常不满意",per:'0%', value: 0},
              ]
          response.data.map(el=>{
            if(el.Num !==0){
              this.chuangkou.push((el.OrgCode === '1001' ? 'A' : (el.OrgCode === '1002' ? 'B' : 'C'))+el.Window)
              this.fmanyi.push(el.Num)
              this.hmanyi.push(0)
              this.yiban.push(0)
              this.manyi.push(0)
              this.bu.push(0)
            }
          })
          this.qhslnum = response.data.reduce((acc, cur) => acc + cur.Num, 0);
        });
      // this.pbcFun.axios
      //   .http("https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=AppCountWindow&OrgCode=" + this.qufen +
      //       "&StartDate=" +
      //       String(this.urlTime.year) +
      //       "-" +
      //       this.urlTime.month +
      //       "-" +
      //       "01" +
      //       "&EndDate=" +
      //       String(this.urlTime.year) +
      //       "-" +
      //       String(this.urlTime.month) +
      //       "-" +
      //       this.urlTime.day)
      //   .then((response) => {
      //     if (response.code === 200) {
      //       if (response.data.length > 0) {
      //         this.manyiduList = [];
      //         this.chuangkou = [];
      //         this.fmanyi = [];
      //         this.hmanyi = [];
      //         this.manyi = [];
      //         this.yiban = [];
      //         this.bu = [];
      //         var arr1 = [],
      //           arr2 = [],
      //           arr3 = [],
      //           arr4 = [],
      //           arr5 = [],
      //           arr6 = [],
      //           App1 = 0,
      //           App2 = 0,
      //           App3 = 0,
      //           App4 = 0,
      //           App5 = 0,
      //           allNum = 0;
      //         for (var i = 0; i < response.data.length; i++) {
      //           arr1.push(response.data[i].WinID);
      //           arr2.push(response.data[i].App5);
      //           arr3.push(response.data[i].App4);
      //           arr4.push(response.data[i].App3);
      //           arr5.push(response.data[i].App2);
      //           arr6.push(response.data[i].App1);
      //           App1 += Number(response.data[i].App1);
      //           App2 += Number(response.data[i].App2);
      //           App3 += Number(response.data[i].App3);
      //           App4 += Number(response.data[i].App4);
      //           App5 += Number(response.data[i].App5);
      //         }

      //         // for (var i = 0; i < arr6.length; i++) {
      //         // 	if (arr6[i] != 0) {
      //         // 		arr6[i] = 0;
      //         // 	}
      //         // }
      //         // for (var i = 0; i < arr3.length; i++) {
      //         // 	if (arr3[i] != 0) {
      //         // 		arr3[i] = 0;
      //         // 	}
      //         // }
      //         // if (App1 > 0) {
      //         // 	App1 = 0;
      //         // }
      //         // if (App4 > 0) {
      //         // 	App4 = 0;
      //         // }

      //         allNum = App1 + App2 + App3 + App4 + App5;
      //         this.manyiduList.push(
      //           { value: App5, name: "非常满意",per: allNum>0 ?"100%":'0%' },
      //           { value: App4, name: "满意",per:'0%' },
      //           { value: App3, name: "基本满意",per:'0%' },
      //           { value: App2, name: "不满意",per:'0%' },
      //           { value: App1, name: "非常不满意",per:'0%' }
      //         );
      //         console.log(manyiduList);
              
      //         // this.manyiduList.forEach((item, index) => {
      //         //   if (allNum > 0 && item.value > 0) {
      //         //     item.per = ((item.value / allNum) * 100).toFixed(2) + "%";
      //         //     // item.per=parseInt(item.value/allNum*100)+'%'
      //         //   } else {
      //         //     item.per = 0;
      //         //   }
      //         // });
      //         this.chuangkou = arr1;
      //         this.fmanyi = arr2;
      //         this.hmanyi = arr3;
      //         this.manyi = arr4;
      //         this.yiban = arr5;
      //         this.bu = arr6;
      //         console.log(this.chuangkou)
      //         console.log(this.manyi)
      //         console.log(this.hmanyi)
      //         console.log(this.yiban)
      //         console.log(this.fmanyi)
      //       }
      //     }
      //   });
    },
    window() {
      this.pbcFun.axios
        .http(
          "https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=WindowCount&StartDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            this.urlTime.day +
            "&EndDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day
        )
        .then((response) => {
          this.qhslnum = response.data.reduce((acc, cur) => acc + cur.Num, 0);
        });
        
              this.xData = [];
              this.yData = [];
      this.pbcFun.axios
        .http(
          "https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=WindowCount&StartDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            "01" +
            "&EndDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day
        )
        .then((response) => {
          console.log('当月各业务窗口办件情况');
          console.log("https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=WindowCount&StartDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            "01" +
            "&EndDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day);
            console.log(response);
            
          
          if (response.code === 200) {
        this.averageTime = response.data.reduce((acc, cur) => acc + cur.Num, 0);
            if (response.data.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                if(response.data[i].Num !== 0){
                  this.xData.push((response.data[i].OrgCode === '1001' ? 'A' : (response.data[i].OrgCode === '1002' ? 'B' : 'C'))+response.data[i].Window);
                this.yData.push(response.data[i].Num);
                }
              }
            }
          }
        });
    },
    fuwu() {
      this.pbcFun.axios.http(this.url+"/api/home/getWindowLists?type=1").then((response) => {
        if(response.length >4){
        this.serverList = response.slice(0,4)
        }else{
        this.serverList = response
        }
      })
    },
    processing() { // 月度业务办理 列表
      this.pbcFun.axios.http(this.url+"/api/home/getHeXiPoYuMonthlySummary"+"?startDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            "01" +
            "&endDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day).then((response) => {
        this.businessList = response.map(el=>{
          el.value = Number(el.value)
          return el
        })
        // this.businessList = [
        //   {
        //     name:'出入境服务',
        //     value:31.14
        //   },
        //   {
        //     name: "交警车务服务",
        //     value:25.90
        //   },
        //   {
        //     name: "居民身份证和户籍服务",
        //     value:33.75
        //   },
        //   {
        //     name: "人力社保和海河英才服务",
        //     value:9.21
        //   }
        // ]
      })
    },
    shixiang() {
      this.pbcFun.axios.http(this.url+"/api/home/getStatisticsOne").then( async (response) => {
        // this.allDay = response.serviceDays
        // this.averageTime = response.totalCases
        // this.average = response.monthlyCases
        // [60, 80, 60, 73, 60, 68,47 ]
        // this.xData = [response.housingCases,response.personnelCases,response.haiheTalentCases,response.trafficPoliceCases,response.trafficManageCases,response.publicSecurityCases,response.entryExitCases]
        // this.ssyyList.today = Number(response.personnelSatisfaction)
        // this.ssyyList.history = Number(response.publicSecuritySatisfaction)
        // this.ssyyList.list = Number(response.trafficPoliceSatisfaction)
        this.shangbao = Number(response.completionRate)
        // this.banjie = Number(response.rejectionRate)
        // this.zong = response.completionNumber
        //当日满意度
        this.verySatisfiedNum =response.verySatisfiedNum
        this.basicallySatisfiedNum =response.basicallySatisfiedNum
        this.generallySatisfiedNum =response.generallySatisfiedNum
        this.dissatisfiedNum =response.dissatisfiedNum

					const resl = await this.pbcFun.axios.http('https://byapi.shyunhua.com/api/home/getBusinessLists')
        this.zong = resl.reduce((acc, cur) => acc + Number(cur.total), 0)
          // this.businessList = [
        //   {
        //     value: Number(response.housingMonthlyCompletionRate),
        //     name: "住建",
        //   },
        //   {
        //     value: Number(response.personnelCompletionRate),
        //     name: "人社",
        //   },
        //   {
        //     value: Number(response.haiheTalentCompletionRate),
        //     name: "海河英才",
        //   },
        //   {
        //     value: Number(response.trafficPoliceCompletionRate),
        //     name: "交警",
        //   },
        //   {
        //     value: Number(response.trafficManagementCompletionRate),
        //     name: "交管",
        //   },
        //   {
        //     value: Number(response.publicSecurityCompletionRate) ,
        //     name: "公安",
        //   },
        //   {
        //     value: Number(response.entryExitCompletionRate),
        //     name: "出入境",
        //   }
        // ]
      })
    },
    getManyiList() {
      this.pbcFun.axios
        .http(
          "https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=AppCount&OrgCode=" +
            this.qufen +
            "&StartDate=" +
            String(this.urlTime.year) +
            "-" +
            this.urlTime.month +
            "-" +
            "01" +
            "&EndDate=" +
            String(this.urlTime.year) +
            "-" +
            String(this.urlTime.month) +
            "-" +
            this.urlTime.day
        )
        .then((response) => {
          if (response.code == 200) {
           this.verySatisfiedNum = response.data.App5
           this.basicallySatisfiedNum = response.data.App4
           this.generallySatisfiedNum = response.data.App3
           this.dissatisfiedNum = response.data.App2
          }
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/page/index.vue